export default __webpack_public_path__ + "static/media/Icons_2.c85a8f9c.svg";